﻿import $ from 'jquery';

export class AutoHeightTable {

  public static get wireup(): string { return 'auto-height-table'.asDataSelector(); }

  constructor($element: JQuery, options: any) {
    const tableRowHeight = 32;
    let rowCount = $element.find('tbody tr').length;
    let tableHeight = (rowCount + 1) * tableRowHeight;

    $element.height(tableHeight);
  }
}

function Plugin(option, args) {
  return this.each(function () {
    let $this = $(this);
    let data = $this.data('rustig.autoheighttable');
    let options = typeof option === 'object' && option;

    if (!data) {
      data = new AutoHeightTable($this, options);
      $this.data('rustig.autoheighttable', data);
    }
    if (typeof (option) == 'string')
      data[option](args);
  })
}

declare global {
  interface JQuery {
    autoheighttable: (option, args) => any;
  }
}

$.fn.autoheighttable = Plugin;